angular.module('picmonicng').directive('examSelect', [
  'ExamOptionsConfig',
  '$filter',
  function (ExamOptionsConfig, $filter) {
    return {
      restrict: 'E',
      scope: {
        examId: '=',
        market: '=',
      },
      link: function (scope, element, attrs) {
        scope.examOptions = ExamOptionsConfig.exams;
      },
      template:
        '<select class="form-control" ng-model="examId" ng-change="$parent.updateDropdowns(\'exam\')" ng-options="examOption.id as examOption.name for examOption in examOptions | filter: {lead: market} | orderBy: \'id\'"><option value="">Select</option>{{examOption.name}}</option></select>',
    };
  },
]);
